export default __webpack_public_path__ + "static/media/icons8-people-64.dfaaefbf.svg";